import type { HumanSupportContext, HumanSupportDraft, HumanSupportTicket } from "@cross-border-agent/contracts";
import { ApiError } from "./api";

export const emptySupportContext = (): HumanSupportContext => ({ summary: "", platform: "", shareConversation: false, shareTask: false, sharePage: false });
export const supportStatus: Record<HumanSupportTicket["status"], string> = { waiting: "待辅导", in_progress: "辅导中", completed: "已完成", refunding: "退款处理中", refunded: "已退款" };
export function draftIsUsable(draft: HumanSupportDraft | null, now = Date.now()): boolean {
  return Boolean(draft && draft.status === "draft" && new Date(draft.expiresAt).getTime() > now);
}
export function supportErrorText(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 401) return "登录已失效，请重新登录后继续，当前链接会保留。";
    if (error.status === 403 || error.status === 404) return "当前账户无法读取这份记录。请确认网页与插件登录的是同一账户；也可以重试或重新填写问题。";
    if (error.status >= 500) return "真人辅导服务暂时不可用，请稍后重试。已有订单不会因此丢失，请勿重复付款。";
    return error.message;
  }
  if (error instanceof Error && /登录|账户/.test(error.message)) return error.message;
  return "网络连接暂时没有完成，请检查网络后重试。已有问题和订单不会因此删除。";
}
export function supportPath(search = ""): string { return `/human-support${search}`; }
const RETURN_KEY = "xiaoman-support-login-return";
export function rememberSupportLoginReturn(): void {
  if (location.pathname !== "/human-support" && !(location.pathname === "/plans" && new URLSearchParams(location.search).has("supportDraft"))) return;
  try { sessionStorage.setItem(RETURN_KEY, supportPath(location.search)); } catch { /* Login remains available if browser storage is restricted. */ }
}
export function takeSupportLoginReturn(): string {
  try {
    const raw = sessionStorage.getItem(RETURN_KEY); sessionStorage.removeItem(RETURN_KEY);
    if (raw) {
      const url = new URL(raw, location.origin);
      if (url.origin === location.origin && url.pathname === "/human-support") return url.pathname + url.search;
    }
  } catch { /* Fall back to the user's home. */ }
  return "/account";
}
